import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

import { FeatureFlagKeys, selectFlagOnceLoaded } from '@ninety/platform/state';

/**
 * Gates the whole `/inbox` route behind `web-inbox`. `canMatch`, not `canActivate`, so the lazy
 * chunk is never fetched and the URL falls through to the `**` redirect — a deep link with the
 * flag off lands on home rather than an empty shell.
 *
 * IMPORTANT: wait until LaunchDarkly flags have actually loaded before reading the flag, otherwise
 * the guard resolves on the pre-load default (false) and the route is skipped for everyone.
 * `selectFlagOnceLoaded` reads both as one projection — combining two selectors puts the new marker
 * beside the old flag for one emission, which is the same bug wearing a disguise.
 * Mirrors `partnerManagementV2FlagOn`.
 */
export const inboxFlagGuard: CanMatchFn = () => {
  const store = inject(Store);
  return store.select(selectFlagOnceLoaded(FeatureFlagKeys.inbox)).pipe(
    filter(({ loaded }) => loaded),
    take(1),
    map(({ on }) => on)
  );
};
